import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { useLocalStorage } from "./LocalStorageHook";

export default async function GetCustomerSpecific(
  salesOrg: string,
  guid: string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/customer/?customerNum=${guid}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetCustomerRaw(salesOrg: string, customerNum: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
    },
    url: `${BASE_URL}/api/recommendation/raw`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetSettlementInfoSpecific(
  salesOrg: string,
  cusnum: string
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/customer/settlement?customerNum=${cusnum}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetDexInfoSpecific(
  salesOrg: string,
  cusnum: string,
  dexidentifier?:string,
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      identifier:dexidentifier,
    },
    url: `${BASE_URL}/api/customer/dex?number=${cusnum}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetVisitTimeInfoSpecific(
  salesOrg: string,
  cusnum: string
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/customer/visit?customerNum=${cusnum}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetSeasonality(
  salesOrg: string,
  customerNum: string
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/seasonality/customer?custid=${customerNum}`,
  };
 
  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetSalesInfoSpecific(
  salesOrg: string,
  cusnum: string
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/customer/sales?customerNum=${cusnum}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export interface CustomerNotes {
  noteType: string;
  text: string;
  isDeleted: boolean;
  isImportant: boolean;
  validUntilDt: Date;
  createdBy: string;
  createdDt: Date;
  guid?: string;
}
export interface noteMeta {
  maxLength: number;
  validTypes: { code: string; text: string }[];
}
export async function GetNotes(salesOrg: string, cusnum?: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      lang: "EN",
    },
    url: `${BASE_URL}/api/customer/notes?customerNum=${cusnum}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

interface localFavoriteStats {
  sales_units: number;
  total_sales: number;
  min_percent_volume: number;
  max_percent_volume: number;
  cust_count: number;
  acv_sales: number;
  percent_volume: number;
  acv: number;
}
export interface localFavorite {
  material_num: string;
  material_num_short: string;
  description: string;
  brand: string;
  pack_size: string;
  pack_type: string;
  pack_filter: string;
  flavor: string;
  on_aml: boolean;
  fits_in_machine: boolean;
  con: localFavoriteStats | undefined;
  fsv: localFavoriteStats | undefined;
  all: localFavoriteStats | undefined;
}
export async function GetLocalFavorite(
  salesOrg: string,
  customerNum: string,
  milesRange: number,
  daysBack: number
): Promise<localFavorite[]> {
  daysBack = daysBack > 60 ? 60 : daysBack;
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      lang: "EN",
      customerNum,
      milesRange,
      daysBack,
    },
    url: `${BASE_URL}/api/customer/localFavorites`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data.favorites || [])
    .catch((err) => console.error(err));
}

export interface tradeChannelACV {
  client_id: number;
  sales_org: string;
  trade_channel: string;
  brand: string;
  flavor: string;
  sales_units: number;
  total_sales: number;
  min_percent_volume: number;
  max_percent_volume: number;
  cust_count: number;
  acv_sales: number;
  percent_volume: number;
  acv: number;
}
export async function GetTradeChannelACV(
  salesOrg: string,
  customerNum: string,
  daysBack: number
): Promise<tradeChannelACV[]> {
  daysBack = daysBack > 60 ? 60 : daysBack;
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      daysBack,
    },
    url: `${BASE_URL}/api/customer/tradeChannelACV`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data.tradeChannelACVs || [])
    .catch((err) => console.error(err));
}
